import { Button, Input, Space, Typography } from 'antd';
import { PatientInfoState } from 'features/patient/_utils/patient-info/patient-info-slice-types';
import { setExtraRecommendations } from 'features/patient/_utils/patient-info/patientInfoSlice';
import { useEffect, useState } from 'react';
import { TreatmentCard } from './treatment-card';

export function ClinicianRecommendations(props: {
  patientInfo: PatientInfoState;
  patientInfoDispatch: React.Dispatch<any>;
}) {
  const [text, setText] = useState(
    props.patientInfo.concussion!.extraRecommendations
  );

  useEffect(
    () => {
      setText(props.patientInfo.concussion?.extraRecommendations);
    },
    // eslint-disable-next-line
    [props.patientInfo.concussion?.extraRecommendations]
  );

  return (
    <TreatmentCard title={'Clinician Recommendations'}>
      <Space direction="vertical">
        <Typography style={{ fontWeight: 'bold' }}>
          It will be automatically added to the other prescriptions when you
          print them.
        </Typography>
        <Input.TextArea
          placeholder={`Enter any other recommendations you have for ${props.patientInfo.patient.displayName} here!`}
          autoSize={{ minRows: 2 }}
          value={text}
          onChange={e => setText(e.target.value)}
        />
        <Button
          onClick={() => {
            if (!text) return;
            props.patientInfoDispatch(setExtraRecommendations(text));
          }}
          loading={props.patientInfo.isLoading}
        >
          Save
        </Button>
      </Space>
    </TreatmentCard>
  );
}
